import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XText } from "IZOX/_X";
import _ from "lodash";
import PAPopupReceipts from "./PAPopupReceipts";
import QUICKUI from "shared/QUICKUI";
import PolicyRow from "shared/PolicyRow";
import { PageFlipper } from "IZOX/BLOCKS/Libs";

/**
 * @augments {Component<Props, State>}
 */
class PAExSoon extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      page: 0,
      pageSize: 5
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetPolicies();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAExSoon.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  GetPolicies = async () => {
    let {page, pageSize} = this.state;
    let res = await ReqX.SendBE("/Web/Agent/GetPolicies", {
      status: "ExpirySoon",
      page: page,
      pageSize: pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count
      });
    }
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    });
  }

  _toDoc = (_id) => {

  }

  _toPopupReceipts = async (_id) => {
    let res = await ReqX.SendBE("/Web/Agent/ViewPolicy", {
      docID: _id
    });
    let {Success, payload} = res;
    if(Success){
      let {policyDoc, receiptDocs} = payload;
      GFunc.Backdrop(() => {
        return (
          <PAPopupReceipts policyDoc={policyDoc} receiptDocs={receiptDocs}/>
        );
      }, {}, false);
    }
  }

  renderRemark(){
    return (
      <HStack bColor={ColorX.CSS("Stone")} bW={1} p={8} 
        bgColor={ColorX.CSS("pureWhite")}
        HAlign="[">
        <XText fullWidth fontSize={10}>
          {LocaleX.Parse({
            EN: "Remark: Please note that the dashboard data has a one-day delay.",
            TC: "備註：請注意概覽資料有一天的延遲。"
          })}
        </XText>
      </HStack>
    );
  }

  renderVertBox(label, value, style, containerStyle){
    return (
      <VStack fitWidthToContent HAlign="[" mH={5} style={containerStyle}>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Stone")} fontSize={13}
            style={style} fullWidth>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderPolicyDoc(doc, idx){
    let {_id} = doc;
    return (
      <PolicyRow key={idx} policyDoc={doc} isDashboard
        onViewDetailPress={() => this._toPopupReceipts(_id)}/>
    );
  }

  renderDocs(){
    let {docs, page, pageSize} = this.state;

    if(_.isEmpty(docs)){
      return QUICKUI.NoDocs({
        EN: "There is no recent policies will expire within 1 months.",
        TC: "近期沒有保單會在1個月內到期。"
      });
    }
    let _docs = _.slice(docs, page * pageSize, (page + 1) * pageSize);

    return (
      <VStack fullWidth pV={24}>
        {_.map(_docs, (o, i) => {
          return this.renderPolicyDoc(o, i);
        })}
        <PageFlipper totalDocs={docs.length} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          mainColor={ColorX.CSS("Axit")} />
      </VStack>
    );
  }

  render(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")} p={18} >
        {this.renderRemark()}
        {this.renderDocs()}
      </VStack>
    );
  }

}

export default observer(PAExSoon);
